module.exports = __webpack_public_path__ + "img/testimonial_4.cbd827e6.png";